<div class="video-call-message">
  <ng-container *ngIf="!body.end_time && body.status === 1">
    <i class="fa fa-volume-control-phone fa-fw"></i>
    <div class="income-call-container" *ngIf="!message.isSentByMe && !isVideoCall">
      <span>{{'WEBCLIENT.CHATROOM.VIDEO_CALL.INCOMING_CALL' | translate}}...</span>
      <hr />
      <span class="join-btn">{{'WEBCLIENT.CHATROOM.VIDEO_CALL.JOIN' | translate}}</span>
    </div>
    <!-- <span *ngIf="message.isSentByMe && !isVideoCall">發送通話中</span> -->
    <span *ngIf="isVideoCall" class="video-calling-container">{{'WEBCLIENT.CHATROOM.VIDEO_CALL.IN_CALL' | translate}}...</span>
  </ng-container>
  

  <ng-container *ngIf="body.end_time && body.status === 0">
    <i class="fa fa-phone fa-fw"></i>
    <span>{{'WEBCLIENT.CHATROOM.VIDEO_CALL.CALL_ENDED' | translate}}</span>
  </ng-container>
</div>
 